import axios, {AxiosResponse} from 'axios'

const API_URL = process.env.REACT_APP_THEME_API_URL

// ─── Interfaces ───────────────────────────────────────────────────────────────

export interface Warehouse {
  warehouse_id: number
  warehouse_name: string
  street_address: string
  city: string
  state: string
  country: string
  zip_code: string
  contact_person: string
  email: string
  phone_number: string
  warehouse_type: string
  status: string
}

// ─── Warehouse APIs ───────────────────────────────────────────────────────────

export const getWarehouses = async (companyId: string): Promise<Warehouse[] | undefined> => {
  return await axios
    .get(`${API_URL}/warehouse/list/${companyId}`)
    .then((response: AxiosResponse<Warehouse[]>) => response.data)
    .then((response: Warehouse[]) => response)
}

export const createWarehouse = async (body: any): Promise<{detail: string} | undefined> => {
  try {
    const response = await axios.post(`${API_URL}/warehouse/`, body)
    return response.data
  } catch (error: any) {
    if (error.response) {
      throw error.response.data
    }
  }
}

export const editWarehouse = async (body: any): Promise<{detail: string} | undefined> => {
  try {
    const response = await axios.put(`${API_URL}/warehouse/`, body)
    return response.data
  } catch (error: any) {
    if (error.response) {
      throw error.response.data
    }
  }
}

export const deleteWarehouse = async (
  warehouseId: number
): Promise<{detail: string} | undefined> => {
  return await axios
    .delete(`${API_URL}/warehouse/${warehouseId}`)
    .then((response: AxiosResponse<{detail: string}>) => response.data)
    .then((response: {detail: string}) => response)
}
